import { render, staticRenderFns } from "./StemwijzerCta.vue?vue&type=template&id=c3b505a4&scoped=true&"
import script from "./StemwijzerCta.vue?vue&type=script&lang=js&"
export * from "./StemwijzerCta.vue?vue&type=script&lang=js&"
import style0 from "./StemwijzerCta.vue?vue&type=style&index=0&id=c3b505a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b505a4",
  null
  
)

export default component.exports